import { Link } from './Link';

interface LocationTabProps {
  name: string;
  address: string;
  isActive?: boolean;
  href: string;
}

export const LocationTab = ({
  name,
  address,
  isActive = false,
  href,
}: LocationTabProps) => {
  return (
    <Link href={href} className="block w-full group">
      <div
        className={`flex items-center justify-between gap-6 py-7 transition-colors duration-300 ${
          isActive ? '' : 'opacity-90 hover:opacity-100'
        }`}
      >
        <div className="flex items-start gap-5">
          <span
            className={`mt-2 shrink-0 w-1.5 h-1.5 rounded-full transition-all ${
              isActive ? 'bg-[#F5B800] shadow-[0_0_0_4px_rgba(245,184,0,0.18)]' : 'bg-[#0D0A00]/20 group-hover:bg-[#0D0A00]/45'
            }`}
          />
          <div>
            <h3 className="text-[#0D0A00] text-[24px] md:text-[26px] font-medium tracking-[-0.02em] leading-tight">
              {name}
            </h3>
            <p className="mt-1 text-[14px] text-[#0D0A00]/50">
              {address}
            </p>
          </div>
        </div>
        <span className="shrink-0 text-[#0D0A00]/40 group-hover:text-[#0D0A00] group-hover:translate-x-1 transition-all">
          <svg width="18" height="18" viewBox="0 0 12 12" fill="none">
            <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>
    </Link>
  );
};
